import React, { useState, useEffect } from "react";
import AudioBanner from "./AudioBanner";
import SliderFirst from "./SliderFirst";
import DataLoader from "../../../Utils/DataLoader";
import SpcificPageModal from "../../Modals/SpcificPageModal";
import { useDispatch, useSelector } from "react-redux";
import { apiData } from "../../../actions";
import { Audio_Tour } from "../../../Redux/Action/Action";
import Favorite from '../../../assets/images/Favorite-bg5.png';

export default function AudioTourIndex() {
  const dispatch = useDispatch();
  const place = useSelector((state) => state.place);

  const [tourData, setTourData] = useState(null);
  const [inclusiveScript, setInclusiveScript] = useState("");
  const [loader, setLoader] = useState(false);
  const [specificModal, setSpecificModal] = useState(false);

  /* ===================== API CALLS ===================== */

  const getTour = async () => {
    if (!place) return;

    try {
      setLoader(true);
      const payload = { city: place };
      const apiRes = await apiData.audioTour(payload);

      if (apiRes?.status >= 200 && apiRes?.status <= 399) {
        setTourData(apiRes?.data?.data);
      }
    } catch (err) {
      console.error("Audio Tour API error", err);
    } finally {
      setLoader(false);
    }
  };

  const getWigoTourScript = async () => {
    if (!place) return;

    try {
      setLoader(true);
      const payload = { city: place };
      const apiRes = await apiData.getWigoTour(payload);

      if (apiRes?.status >= 200 && apiRes?.status <= 399) {
        const scriptUrl = apiRes?.data?.data?.[0]?.content?.split('"')[1];
        setInclusiveScript(scriptUrl || "");
      }
    } catch (err) {
      console.error("Wigo Script API error", err);
    } finally {
      setLoader(false);
    }
  };

  /* ===================== SCRIPT LOAD ===================== */

  useEffect(() => {
    if (!inclusiveScript) return;

    const container = document.getElementById("InclusiveScript");
    if (!container) return;

    container.innerHTML = "";

    const script = document.createElement("script");
    script.src = inclusiveScript;
    script.async = true;

    container.appendChild(script);

    return () => {
      container.innerHTML = "";
    };
  }, [inclusiveScript]);

  /* ===================== PLACE CHANGE ===================== */

  useEffect(() => {
    if (!place) return;

    getWigoTourScript();
    getTour();
    dispatch(Audio_Tour()); // enable if required
  }, [place]);

  /* ===================== MODAL LOGIC ===================== */

  useEffect(() => {
    const hasSeenPopup = localStorage.getItem("hasSeenSpecficPopup");

    if (!hasSeenPopup && place) {
      setSpecificModal(true);
      localStorage.setItem("hasSeenSpecficPopup", "true");
    }

    const handleVisibilityChange = () => {
      if (document.visibilityState === "hidden") {
        localStorage.setItem("lastSeen", Date.now());
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () =>
      document.removeEventListener("visibilitychange", handleVisibilityChange);
  }, [place]);

  /* ===================== RENDER ===================== */

  return (
    <>
      {loader && <DataLoader />}

      {!loader && (
        <>
          <AudioBanner />

          <section className="section-equal-padding deals_section audio_pages uk-scrollspy-inview pb-0">
            <div className="container-fluid">
              <div id="InclusiveScript" />
            </div>

            <SliderFirst tourData={tourData} />


            <section className="section-equal-padding favorite-section things-favorite uk-scrollspy-inview"
              style={{backgroundImage: `url(${Favorite})`}}
              uk-scrollspy="cls: uk-animation-slide-bottom; delay: 400; repeat: false">
              <div className="container-fluid d-flex justify-content-center text-center">
                <div className="favorite-block uk-scrollspy-inview"
                  uk-scrollspy="cls: uk-animation-slide-bottom; delay: 400; repeat: false">
                  <h2 className="mb-4">Get Ready for an Adventure!</h2>
                  <p>
                    Start your journey with us, where we guarantee the lowest prices. Book top hotel rooms for $20-$30
                    less per night and save $25-$50 on flights compared to other travel sites. Explore our site, grab
                    great deals, and let the thrill of savings fuel your dream getaway!
                  </p>
                  <a href="" className="white-btn mt-3">Browse Full Menu</a>
                </div>
              </div>
            </section>

          </section>
        </>
      )}

      {specificModal && (
        <SpcificPageModal
          specificModal={specificModal}
          setSpecificModal={setSpecificModal}
        />
      )}
    </>
  );
}
